import { Helmet } from "react-helmet-async";
import { useLocale } from "@/i18n/LocaleProvider";

const SITE = "https://selfeducate.app";

interface SeoProps {
  title: string;
  description: string;
  /** Canonical path WITHOUT locale prefix (e.g. "/faq", not "/en/faq"). */
  path: string;
  type?: "website" | "article";
  image?: string;
}

export const Seo = ({ title, description, path, type = "website", image }: SeoProps) => {
  const { locale } = useLocale();
  const cleanPath = path.startsWith("/") ? path : `/${path}`;
  const roUrl = `${SITE}${cleanPath === "/" ? "" : cleanPath}` || SITE;
  const enUrl =
    cleanPath === "/" ? `${SITE}/en` : `${SITE}/en${cleanPath}`;
  const currentUrl = locale === "en" ? enUrl : roUrl;

  return (
    <Helmet>
      <html lang={locale} />
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={currentUrl} />
      <link rel="alternate" hrefLang="ro" href={roUrl} />
      <link rel="alternate" hrefLang="en" href={enUrl} />
      <link rel="alternate" hrefLang="x-default" href={roUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={currentUrl} />
      <meta property="og:type" content={type} />
      <meta property="og:locale" content={locale === "en" ? "en_US" : "ro_RO"} />
      <meta property="og:locale:alternate" content={locale === "en" ? "ro_RO" : "en_US"} />
      {image && <meta property="og:image" content={image} />}
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      {image && <meta name="twitter:image" content={image} />}
    </Helmet>
  );
};

export default Seo;
